<router-outlet></router-outlet>

<ng-template #loginPopupTemplate>
    <div class="modal-body text-center p-5">
        <h4>{{ 'login.signin' | translate }}</h4>
        <app-login [modal]="true"></app-login>
    </div>
</ng-template>